import React from 'react'
import styled from 'styled-components'

const Base = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.text};
`

const H1Root = styled(Base)`
  font-size: ${({ theme }) => theme.fontSizes.xxl};
  font-weight: 700;
`

const H2Root = styled(Base)`
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: 600;
`

const H3Root = styled(Base)`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: 600;
`

const TextRoot = styled(Base)`
  font-size: ${({ size }) => size || '16px'};
  font-weight: ${({ weight }) => weight || 'normal'};
  color: ${({ color }) => color || 'inherit'};
`

export function H1({ children, style, ...props }) { return <H1Root style={style} {...props}>{children}</H1Root> }
export function H2({ children, style, ...props }) { return <H2Root style={style} {...props}>{children}</H2Root> }
export function H3({ children, style, ...props }) { return <H3Root style={style} {...props}>{children}</H3Root> }
export function Text({ children, size, weight, color, style }) {
  return <TextRoot size={size} weight={weight} color={color} style={style}>{children}</TextRoot>
}
